import { render } from "./SponsorShipView.vue?vue&type=template&id=597c5182"
import script from "./SponsorShipView.vue?vue&type=script&lang=js"
export * from "./SponsorShipView.vue?vue&type=script&lang=js"

import "./SponsorShipView.vue?vue&type=style&index=0&id=597c5182&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__